import {Component, OnInit} from '@angular/core';
import {Usuario} from '../model/usuario';
import {functionUtil, functionHelper} from 'src/app/util/functionConst';
import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';
import {LoginService} from './login.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ParametrosConst} from 'src/app/util/parametrosConst';
import {AlertaService} from 'src/app/util/alerta.service';
import {AppConfigService} from 'src/app/app-config.service';


@Component({
  selector: 'sura-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public rc = new UntypedFormControl('', Validators.required);

  hide = true;
  uduarioForm: UntypedFormGroup;
  recaptchaStr = '';
  fnKeyDownAlphaNumeric = functionUtil.fnKeyDownAlphaNumeric;
  fnAlphaNumericMobile = functionUtil.fnAlphaNumericMobile;
  fnInputMaxLength = functionUtil.fnInputMaxLength;
  returnUrl: string;

  constructor(
    private appConfigService: AppConfigService,
    private _loginService: LoginService,
    private alertaService: AlertaService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.uduarioForm = new UntypedFormGroup({
      usuario: new UntypedFormControl('', [Validators.required]),
      clave: new UntypedFormControl('', [Validators.required]),
      recaptchaReactive: new UntypedFormControl('')
    });
  }

  ngOnInit() {
    // reset login status
    this._loginService.logout();
    // get return url from route parameters or default to '/'
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || ParametrosConst.URL_ROUTER_INTRANET_HOME;
  }

  onLoginClick(captchaRef: any): void {
    if (this.uduarioForm.invalid) {
      return;
    }
    if (this.recaptchaStr) {
      captchaRef.reset();
    }
    captchaRef.execute();
  }

  /*Verificar el capctcha*/
  public resolved(captchaResponse: string): void {
    this.recaptchaStr = captchaResponse;
    if (this.recaptchaStr) {
      this.varificarUsuario();
    }
  }

  varificarUsuario() {
    if (this.uduarioForm.invalid) {
      return;
    }
    let usuario = new Usuario;
    usuario.usuario = this.uduarioForm.value.usuario;
    usuario.clave = this.uduarioForm.value.clave;
    try {
      this._loginService.verificarUsuario(usuario).subscribe(response => {
        this._loginService.validarIngreso(usuario).then((data: any) => {
          usuario = new Usuario;
          usuario.apellidos = data.usuarioAsamblea.apellidos;
          usuario.correo = data.usuarioAsamblea.correo;
          usuario.estado = data.usuarioAsamblea.estado;
          usuario.usuario = data.usuarioAsamblea.nombreUsuario;
          usuario.nombres = data.usuarioAsamblea.nombres;
          usuario.numeroDocumento = data.usuarioAsamblea.numeroDocumento;
          usuario.tipoDocumento = data.usuarioAsamblea.tipoDocumento;
          usuario.sesion = data.usuarioAsamblea.sesion;
          localStorage.setItem(ParametrosConst.USUARIO_MENU, JSON.stringify(data.listaOpciones));
          if (data.usuarioAsamblea.sesion === '0' || data.usuarioAsamblea.sesion == null) {
            if (data.advertencia == null) {
              this.router.navigate([ParametrosConst.URL_ROUTER_CAMBIO_CONTRASENIA], {queryParams: {returnUrl: '/ingreso'}});
            } else {
              this.alertaService.warning(data.advertencia);
              setTimeout(() => {
                this.router.navigate([ParametrosConst.URL_ROUTER_CAMBIO_CONTRASENIA], {queryParams: {returnUrl: '/ingreso'}});
              }, ParametrosConst.TIEMPO_ADVERTENCIA_EXPIRACION_CONTRASENIA);
            }
          } else {
            if (data.advertencia == null) {
              this.router.navigate([this.returnUrl]);
            } else {
              this.alertaService.warning(data.advertencia);
              setTimeout(() => {
                this.router.navigate([this.returnUrl]);
              }, ParametrosConst.TIEMPO_ADVERTENCIA_EXPIRACION_CONTRASENIA);
            }
          }
          localStorage.setItem(ParametrosConst.USUARIO_LOGIN, JSON.stringify(usuario));
        }).catch(er => {
          this.alertaService.error(er);
        });
      }, error => {
        this.alertaService.error(error);
      });
    } catch (error) {
      this.alertaService.error(error);
    }
  }

  hasError(controlName: string) {
    return this.uduarioForm.controls[controlName].invalid;
  }

  obtenerMensajeError(controlName: string) {
    return functionHelper.extraerErrorGroup(this.uduarioForm, controlName);
  }
}
